import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import userService from "../services/userService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg_img from "../assets/bg.png";

const SignUpPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await userService.register(
        username,
        password,
        "user",
        "active",
        whatsappNumber
      );
      toast.success("রেজিস্ট্রেশন সফল হয়েছে!", { position: "top-right" });
      navigate("/login");
    } catch (err) {
      toast.error(
        "রেজিস্ট্রেশন ব্যর্থ হয়েছে: " +
          (err.response?.data?.error || err.message),
        {
          position: "top-right",
        }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        fontFamily: "'Inter', sans-serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundAttachment: "fixed",
          //  transform: "perspective(600px) rotateX(15deg) rotateY(15deg)", // Static 3D tilt
          zIndex: 1,
          opacity: 1, // Fully opaque
        }}
      ></div>
      <ToastContainer style={{ zIndex: 99999 }} />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "400px",
          width: "100%",
          boxShadow:
            "0 15px 50px rgba(0, 0, 0, 0.3), 0 0 20px rgba(16, 185, 129, 0.2)", // Static 3D shadow
          textAlign: "center",
          transform: "perspective(600px) translateZ(30px)", // Static 3D effect
          position: "relative",
          zIndex: 3,
        }}
      >
        <h1
          style={{
            fontSize: "1.875rem",
            fontWeight: 700,
            color: "#1f2937",
            marginBottom: "24px",
          }}
        >
          সাইন আপ
        </h1>
        <form onSubmit={handleSignUp}>
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="username"
              style={{
                display: "block",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              ইউজারনেম
            </label>
            <input
              type="text"
              id="username"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "1rem",
                color: "#1f2937",
                backgroundColor: "#f9fafb",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              placeholder="ইউজারনেম লিখুন"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = "#10b981";
                e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              পাসওয়ার্ড
            </label>
            <input
              type="password"
              id="password"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "1rem",
                color: "#1f2937",
                backgroundColor: "#f9fafb",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              placeholder="পাসওয়ার্ড লিখুন"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = "#10b981";
                e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label
              htmlFor="whatsapp"
              style={{
                display: "block",
                fontSize: "1rem",
                fontWeight: 500,
                color: "#4b5563",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              WhatsApp নম্বর
            </label>
            <input
              type="text"
              id="whatsapp"
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "1rem",
                color: "#1f2937",
                backgroundColor: "#f9fafb",
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
              placeholder="WhatsApp নম্বর লিখুন"
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = "#10b981";
                e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.3)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
              required
            />
          </div>
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              background: loading
                ? "linear-gradient(90deg, #9ca3af, #6b7280)"
                : "linear-gradient(90deg, #10b981, #059669)",
              border: "none",
              borderRadius: "9999px",
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
            }}
          >
            {loading ? "লোড হচ্ছে..." : "সাইন আপ"}
          </button>
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
              fontSize: "0.875rem",
              color: "#4b5563",
            }}
          >
            <span>ইতিমধ্যে অ্যাকাউন্ট আছে? </span>
            <button
              style={{
                color: "#10b981",
                background: "none",
                border: "none",
                fontWeight: 600,
                cursor: "pointer",
              }}
              onClick={() => navigate("/login")}
            >
              লগইন
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpPage;
